export default __webpack_public_path__ + "static/media/between.7ab29a95.svg";